import './main.css'
import App from './App.html'

const target = document.querySelector('body')
const app = new App({ target })
